import {css, styled} from '@creditas/stylitas'
import financing from './images/portal-financing-home-banner.png'

const banner = () => css`
  background-image: url(${financing});
  background-repeat: no-repeat;
  height: 100%;
`

const ContainerImage = styled.div`
  ${banner}
`

export { ContainerImage }
